export default __webpack_public_path__ + "static/media/d067e9a2a1e26ace6c41cbb9edc050871598744844405.1fbefda2.webp";